import React, { useState } from 'react'
import { StyleSheet } from 'react-native'

import { B6, Icon, SH3, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { styled } from 'nativewind'
import Animated, { FadeInUp } from 'react-native-reanimated'

const AccordianContainer = styled(Stack, 'bg-neutral-white100  py-4/2')

const AccordianLogoContainer = styled(XStack, 'items-center')
const TitleContainer = styled(Stack, 'ml-2')
const Title = styled(SH3, 'text-grays-100')
const Subtitle = styled(B6, ' text-grays-60')

export function Accordian({
  title,
  subtitle,
  icon,
  eventName,
  eventPayload,
  contentComponent,
  isOpenInit = false,
  isIcon = true,
  brandId,
  ...props
}: any) {
  const [collapsed, setCollapsed] = useState(isOpenInit)

  return (
    <>
      <AccordianContainer {...props}>
        <Pressable
          onPress={() => setCollapsed(!collapsed)}
          eventName={eventName}
          eventPayload={eventPayload}
        >
          <AccordianLogoContainer className="mx-3 py-2">
            {icon && icon}
            <TitleContainer className="flex-1 pl-1">
              <Title>{title}</Title>
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </TitleContainer>
            <Icon type={collapsed ? 'ArrowTop' : 'ArrowDown'} size={24} />
          </AccordianLogoContainer>
        </Pressable>
        <Stack style={styles.border} />
        {collapsed && (
          <Animated.View style={{ flex: 1 }} entering={FadeInUp.duration(500)}>
            {contentComponent ?? null}
          </Animated.View>
        )}
      </AccordianContainer>
    </>
  )
}

const styles = StyleSheet.create({
  border: {
    height: 2,
    backgroundColor: '#ECEFF5',
    marginHorizontal: 15,
    marginTop: 10,
  },
})
